export { CollapseDirective } from './collapse.directive';
export { CollapseModule } from './collapse.module';



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/free/collapse/index.ts